// Copyright (c) 2016 Deere & Company

import './product-link.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';

const ProductLink = props => {

    const productLinkPath = `/products/${props.pin}`;

    const displayText = props.translate ? <FormattedMessage id={props.productLinkText}/> : props.productLinkText;

    return (
        props.isLink ?
            <Link
                className={props.productLinkStyle}
                rel={props.rel}
                target={props.target}
                to={productLinkPath}
            >
                {displayText}
            </Link> :
            <span className={props.productLinkStyle}>
                {displayText}
            </span>
    );

};

ProductLink.displayName = 'ProductLink';
ProductLink.propTypes = {
    isLink: PropTypes.bool,
    pin: PropTypes.string.isRequired,
    productLinkStyle: PropTypes.string,
    productLinkText: PropTypes.string.isRequired,
    rel: PropTypes.string,
    target: PropTypes.string,
    translate: PropTypes.bool.isRequired
};
ProductLink.defaultProps = {
    isLink: true,
    productLinkStyle: 'product-link'
};

export default ProductLink;



// WEBPACK FOOTER //
// ./src/product/shared/components/product-link.js